import { type IDropdownItem } from 'shared/ui'
import {
  type IResponseConversationsOrder,
  type IResponseConversationsOrderKey,
} from 'entities/Conversation/api/types'
import { type OrdersStore } from 'features/DropdownOrder'

export const OrdersItems = (
  items: IResponseConversationsOrder[],
  store: OrdersStore
): IDropdownItem[] => {
  return items.map((item) => {
    return {
      id: item.key,
      label: item.label,
      active: store.order?.key === item.key,
    }
  })
}

export const OrdersAction = (item: IDropdownItem, store: OrdersStore) => {
  const id = item.id as IResponseConversationsOrderKey
  if (id === store.order?.key) return

  store.setItem(id)
}
